module.exports = __webpack_public_path__ + "media/22_Long.76554ec2.mp3";